export default __webpack_public_path__ + "static/media/customer-card.0c19df7d.svg";